module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Sort1-99f5fdf06f4369fb1da917589c5485a8.svg";